import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AccountSnapshotInput } from 'shared';

import { upsertSnapshot } from '../../lib/api/endpoints';

import { snapshotKeys } from './queries';

export function useUpsertSnapshot() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ accountId, input }: { accountId: string; input: AccountSnapshotInput }) =>
      upsertSnapshot(accountId, input),
    onSuccess: (snapshot) => {
      queryClient.setQueryData(snapshotKeys.latest(snapshot.accountId), snapshot);
      void queryClient.invalidateQueries({ queryKey: snapshotKeys.all });
    },
  });
}
